import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=794ae820"
import script from "./page-header.vue?vue&type=script&lang=js"
export * from "./page-header.vue?vue&type=script&lang=js"
import style0 from "./page-header.vue?vue&type=style&index=0&id=794ae820&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('794ae820')) {
      api.createRecord('794ae820', component.options)
    } else {
      api.reload('794ae820', component.options)
    }
    module.hot.accept("./page-header.vue?vue&type=template&id=794ae820", function () {
      api.rerender('794ae820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/page-header.vue"
export default component.exports